/* Elegancecoque - modèle d'iPhone mémorisé (localStorage « ec-model » = handle|libellé, format déjà utilisé par ec-shop.js) */
(function(){
if(window.ECModel){return;}
var KEY='ec-model';
function clean(s){return String(s||'').replace(/\s+(normal|standard)\s*$/i,'').trim();}
function slug(s){return String(s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');}
function norm(s){return clean(s).toLowerCase().replace(/\s+/g,' ').replace(/\s*\/\s*/g,' / ').trim();}
function isGroup(h){return /^grp-iphone-13-14|^iphone-13-14$/.test(h||'');}
function read(){
 var v='';try{v=window.localStorage.getItem(KEY)||'';}catch(e){}
 var i=v.indexOf('|');if(i<1){return null;}
 var h=v.slice(0,i),l=v.slice(i+1);
 if(!h||!l){return null;}
 if(isGroup(h)){return {handle:'grp-iphone-13-14-normal',label:'iPhone 13 / 14'};}
 return {handle:h,label:l};
}
function save(m){
 try{if(m&&m.handle&&m.label){window.localStorage.setItem(KEY,m.handle+'|'+m.label);}else{window.localStorage.removeItem(KEY);}}catch(e){}
 try{document.dispatchEvent(new CustomEvent('ec:model',{detail:m||null}));}catch(e){}
}
/* valeurs de l'option de variante « Modèle iPhone » qui correspondent au modèle (« 17 » et « 17 Normal » sont équivalents) */
function values(m){
 if(!m){return [];}
 if(isGroup(m.handle)){return ['13','14','13 / 14'];}
 return [clean(String(m.label).replace(/^\s*iphone\s*/i,''))];
}
function matches(m,value){var v=norm(value);return values(m).some(function(x){return norm(x)===v;});}
function collHandle(m){if(!m){return '';}return isGroup(m.handle)?'iphone-13-14':m.handle;}
function fromValue(v){
 v=clean(v);if(!v){return null;}
 if(/^13\s*\/\s*14$/.test(v)){return {handle:'grp-iphone-13-14-normal',label:'iPhone 13 / 14'};}
 return {handle:'iphone-'+slug(v),label:'iPhone '+v};
}
function fromHandle(h){
 h=String(h||'').toLowerCase().replace(/-(normal|standard)$/,'');
 if(isGroup(h)){return {handle:'grp-iphone-13-14-normal',label:'iPhone 13 / 14'};}
 var m=h.match(/^iphone-(1[3-9])(?:-(pro-max|pro|plus|air|mini))?$/);
 if(!m){return null;}
 var ver={'pro-max':' Pro Max','pro':' Pro','plus':' Plus','air':' Air','mini':' mini'}[m[2]]||'';
 return {handle:h,label:'iPhone '+m[1]+ver};
}
window.ECModel={read:read,save:save,values:values,matches:matches,collHandle:collHandle,fromValue:fromValue,fromHandle:fromHandle};
})();
